import { render, staticRenderFns } from "./FormCrudDimension.vue?vue&type=template&id=7fcd1290"
import script from "./FormCrudDimension.vue?vue&type=script&lang=js"
export * from "./FormCrudDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports